const React = require("react");
const ReactIntl = require("react-intl");
const injectIntl = ReactIntl.injectIntl;
const defaultMessages = require("../../i18n/messages/default");
const IntlProvider = ReactIntl.IntlProvider;
const YouAndMetroDigital = require("../YouAndMetroDigital/YouAndMetroDigital");
const FooterMinimal = require("../Footer/FooterMinimal");
const Header = require("../Header/Header");
const LoginActions = require("../../actions/LoginActions");
const LoginStore = require("../../stores/LoginStore");
const AppConstants = require("../../constants/AppConstants");
const UrlUtils = require("../../utils/urlUtils");
const PageCase = require("../PageCase/PageCase.js");
const createReactClass = require("create-react-class");
const LoginBoxWrapper = require("../LoginBoxWrapper/LoginBoxWrapper.js");
const { Input, Button } = require("metro-ui-components");
const LoginHiddenFields = require("../Login/LoginHiddenFields.js");
const PasswordField = require("../Password/PasswordField.js");
const LoginHelper = require("../../utils/loginHelper.js");
const LoginHandler = require("../Login/LoginHandler.js");
const ErrorCodes = require("../../utils/ErrorCodes.js");
const InputMask = require("react-input-mask");
const Utils = require("../../utils/Utils");
const AuthMethodsHandler = require("../Login/AuthMethodsHandler.js");
const TwoFactorAuthenticationRenderer = require("../TwoFactorAuthenticationRenderer/TwoFactorAuthenticationRenderer.js");
const ReCaptcha = require("../../utils/ReCaptcha");
const { Modal, ModalContent, Separator, Tooltip } = require("@metro-ui/core");
const { Info } = require('@metro-ui/icons');
require('./customer-login.less');

const CustomerLogin = createReactClass({
  displayName: "CustomerLogin",

  getInitialState() {
    const countryCodes = AppConstants.COUNTRY_CODE_FOR_NUMBERS[
      this.props.countryCode
    ]
      ? AppConstants.COUNTRY_CODE_FOR_NUMBERS[this.props.countryCode]
      : AppConstants.COUNTRY_CODE_FOR_NUMBERS[
      AppConstants.DEFAULT_COUNTRY_CODE
      ];
    return {
      customerComponentLinks: {},
      otherIds: false,
      isPhoneNumber: false,
      otpWithPhone: false,
      maskedCountryCodePhoneNumber: countryCodes.maskedCountryCodePhoneNumber,
      maskedCountryPhoneNumber: countryCodes.maskedCountryPhoneNumber,
      countryCodePhoneNumber: countryCodes.countryCodePhoneNumber,
      caretPosition: null,
      localeId: this.props.localeId,
      showLoginAsEmployeeLinkInInternet: false,
      hideYouAndMetroDigitalComponent: true,
      isSocialModalOpen: false,
      isLoginCardVisible: true,
      focusPasswordInput: false,
      isClientPasswordless: UrlUtils.getParameterByName("passwordless") === 'true',
      isNewVpnEnabled: window.WebConstants.newVpnDetectionEnabled && window.WebConstants.newVpnDetectionEnabled.toString() === 'true' || false
    };
  },

  componentDidMount: function () {
    LoginStore.addChangeListener(this.changeHandler);
    LoginActions.getUserLoginStrategy(
      this.props.countryCode,
      this.props.userType
    );
    this.renderConfirmation(this.props.emailSentForgotPassword,this.props.channelNotification);
    this.renderOtherIdTooltip();
    ReCaptcha.attachRecaptchaScript(this.props.clientId, this.props.realmId);
    this.prefillLoginInput();
    let renderLoginLogic = this.state.isNewVpnEnabled ? this.vpnRequestDetectionV2() : false;
    this.setState({ renderLoginLogic: renderLoginLogic });
  },

  componentDidUpdate() {
    this.renderOtherIdTooltip();
  },

  onValidOtp(otpChannel){
    let props = this.props;
    let queryLoginIdValue = UrlUtils.getParameterByName(AppConstants.UrlParams.LOGIN_ID);
    let responseModeValue =  UrlUtils.getParameterByName(AppConstants.UrlParams.RESPONSE_MODE);
    let redirectToOtp = window.location.protocol + "//" + window.location.host + AppConstants.Links.VALIDATEOTP_URL  +
    AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, props.responseType) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_MODE, responseModeValue) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, props.accountId) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, this.state.localeId) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.PREVIEW, props.preview) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE, props.codeChallenge) + 
    UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE_METHOD, props.codeChallengeMethod) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.OTP_CHANNEL, otpChannel) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.LOGIN_ID, queryLoginIdValue) +
    UrlUtils.appendQueryParam(AppConstants.UrlParams.PASSWORDLESS, true);
    setTimeout(() => {
      window.location.replace(redirectToOtp);
    }, 700);
  },

  renderOtherIdTooltip() {
    const loginIdBox = document.getElementById("loginIdBox");
    const element = loginIdBox
      ? loginIdBox.getElementsByClassName("m-label-link")
      : null;
    if (element && element[0] && element[0].children.length == 0) {
      const x = document.createElement("SPAN");
      const t = document.createTextNode(
        this.props.intl.formatMessage(
          defaultMessages["login.link.OtherId.Tooltip"]
        )
      );
      x.className = "tooltiptext";
      x.appendChild(t);
      element[0].appendChild(x);
    }
  },


  googleAnalyticsSendRegistersEvents(){
    Utils.googleAnalyticsClickEvents('click_on_register','interaction', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false );
  },

  googleAnalyticsSendForgotPassEvents(){
    Utils.googleAnalyticsClickEvents('click_on_forgot_password','interaction', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false );
  },

  changeHandler() {
    let appState = LoginStore.getState();
    //Check for availability of queryparam postlogonurl if present update with redirect_uri
    let customerComponentLinks = UrlUtils.formatCustCompLinks(
      appState.customerComponentLinks || {},
      this.props.redirectRawUrl
    );

    this.setState({
      customerComponentLinks: customerComponentLinks,
      hideYouAndMetroDigitalComponent: appState.hideYouAndMetroDigitalComponent,
      showLoginAsEmployeeLinkInInternet: (appState.showLoginAsEmployeeLinkInInternet === "true"),
      forgotPwdLinkUrl: appState.forgotPwdLinkUrl,
    });
  },

  renderConfirmation(code, channelNotification) {
    if (code == AppConstants.EmailSentCode.FORGOTPASSWORD) {
      // 200 represents the forgot password mail is successfully sent
      if(channelNotification === "email"){
        LoginActions.triggerToast(
          this.props.intl.formatMessage(
            defaultMessages["emailSentForgotPasswordConfirmationMasg"]
          ),
          "success"
        );
      }else{
        LoginActions.triggerToast(
          this.props.intl.formatMessage(
            defaultMessages["emailSentForgotPasswordConfirmationMsgPhone"]
          ),
          "success"
        );
      }

    } else if (code == AppConstants.EmailSentCode.RESETPASSWORD) {
      // 300 represents the reset password is successfully done
      LoginActions.triggerToast(
        this.props.intl.formatMessage(
          defaultMessages["emailSentResetPasswordConfirmationMasg"]
        ),
        "success"
      );
    } else if (code == AppConstants.EmailSentCode.RESETPASSWORDERROR) {
      // 400 represents the some problem is reset password flow
      LoginActions.triggerToast(
        this.props.intl.formatMessage(defaultMessages["resetPasswordError"]),
        "error"
      );
    } else if (code == AppConstants.EmailSentCode.VALIDATETOTPERROR) {
      // 400 represents the some problem is reset password flow
      LoginActions.triggerToast(
        this.props.intl.formatMessage(
          defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]
        ),
        "error"
      );
    }
  },

  
  showToasterOrRedirectToOtpPage(loginId, isClientPasswordless, otpChannelValueParam) { 
      const errorMesage= this.props.intl.formatMessage(defaultMessages["otpResendError"]);
      LoginStore.generateOtpCode(loginId, isClientPasswordless, this.props.userType, this.props.clientId, this.props.responseType,
        this.props.countryCode, this.props.localeId, this.props.realmId, this.props.accountId, this.props.redirectUrl, this.props.state,
        this.props.prompt, this.props.nonce, this.props.scope, this.props.traceId,
        this.props.codeChallenge, this.props.codeChallengeMethod).then((data) =>{
          this.onValidOtp(otpChannelValueParam);
        }).catch((err) => {
            LoginActions.triggerToast(errorMesage,"error");
            return
        })
  },

  onLogin() {
    const { loginId, password, isClientPasswordless } = this.state;

    if (!loginId && isClientPasswordless) {
      return 
    }

    if (!(loginId && password) && !isClientPasswordless) {
      return
    }

    let loginHashID = this.loginId || loginId;

    if (UrlUtils.isSamlFlow()) {
      Utils.setUEHCookie(loginHashID);
      LoginActions.submitSamlLogin(
        this.loginId || loginId,
        this.state.password,
        this.props.userType,
        this.props.clientId,
        this.props.countryCode,
        this.state.localeId,
        this.props.realmId,
        this.props.traceId
      );
    } else {
      if(isClientPasswordless){
        Utils.setUEHCookie(loginHashID);
        let appState = LoginStore.getState();
        LoginActions.getPasswordlessMethods(this.props.clientId, loginId, this.props.userType);
        LoginActions.getPasswordlessInfo(loginId, this.props.userType);

        if(Utils.isFirstMethodOtp(appState.userPasswordlessMethods) && appState.isPasswordlessUser){
          const otpChannelValue = appState.userPasswordlessMethods[0].channel;
          window.localStorage.setItem('userLoginId', JSON.stringify(loginId));
          this.showToasterOrRedirectToOtpPage(loginId, isClientPasswordless, otpChannelValue)
        }else{
          Utils.setUEHCookie(loginHashID);
          // TODO: refactor below code in a function to not be duplicated
          ReCaptcha.getRecaptchaToken((token) =>
            LoginActions.submitLogin(
              this.loginId || loginId,
              this.state.password,
              this.props.userType,
              this.props.clientId,
              this.props.responseType,
              this.props.countryCode,
              this.state.localeId,
              this.props.realmId,
              this.props.accountId,
              this.props.redirectUrl,
              this.props.state,
              this.props.prompt,
              this.props.nonce,
              this.props.scope,
              this.props.traceId,
              this.props.codeChallenge,
              this.props.codeChallengeMethod,
              token
            )
          );
        }
      } else{
        Utils.setUEHCookie(loginHashID);
          ReCaptcha.getRecaptchaToken((token) =>
          LoginActions.submitLogin(
            this.loginId || loginId,
            this.state.password,
            this.props.userType,
            this.props.clientId,
            this.props.responseType,
            this.props.countryCode,
            this.state.localeId,
            this.props.realmId,
            this.props.accountId,
            this.props.redirectUrl,
            this.props.state,
            this.props.prompt,
            this.props.nonce,
            this.props.scope,
            this.props.traceId,
            this.props.codeChallenge,
            this.props.codeChallengeMethod,
            token
          )
        );
      }
    }
  },

  onLoginIdChange(e) {
    const value = e.target.value;
    const caretPosition = this.state.caretPosition;

    if (caretPosition && caretPosition > 0) {
      Utils.setCaretPosition("user_id", caretPosition);
      this.setState({ caretPosition: null });
    }

    if (this.props.allowMobileLogin) {
      const regEx = RegExp("^(\\+?)(\\d+)(\\s\\|\\s)?(\\d*)$", "g");
      const isPhoneNumber = regEx.test(value);
      this.setState({ otpWithPhone: isPhoneNumber });
      if (
        !this.state.otherIds &&
        this.state.isPhoneNumber == true &&
        isPhoneNumber == false
      ) {
        // check and remove occurance of +
        value = value.replace("+", "");
      }

      if (
        !this.state.otherIds &&
        this.state.isPhoneNumber == false &&
        isPhoneNumber == true
      ) {
        // check and add countryCode of +
        if (value && value.indexOf("+") == -1) {
          value = value.replace("+", "");
          value =
            this.state.countryCodePhoneNumber +
            AppConstants.LOGIN_SEPERATOR +
            value;
        } else {
          if (
            value &&
            value.indexOf(AppConstants.LOGIN_SEPERATOR) == -1 &&
            value.length == this.state.countryCodePhoneNumber.length
          ) {
            value =
              value.slice(0, this.state.countryCodePhoneNumber.length) +
              AppConstants.LOGIN_SEPERATOR +
              txt1.slice(this.state.countryCodePhoneNumber.length);
          }
        }
      }

      let transformedValue = value;
      if (!this.state.otherIds && isPhoneNumber) {
        transformedValue = transformedValue.replace("+", "00");
        transformedValue = transformedValue.replace(
          AppConstants.LOGIN_SEPERATOR,
          ""
        );
      }
      this.loginId = transformedValue;

      this.setState({ loginId: value, isPhoneNumber });
    } else {
      this.loginId = value;
      this.setState({ loginId: value });
    }
  },

  beforeMaskedValueChange(newState, oldState, userInput) {
    let { value } = newState;
    let selection = newState.selection;
    let cursorPos = selection ? selection.start : null;

    const regEx = RegExp("^(\\+?)(\\d+)(\\s\\|\\s)?(\\d*)$", "g");
    let isNotPhoneNumber = !regEx.test(userInput);

    if (
      userInput &&
      !this.state.otherIds &&
      this.state.isPhoneNumber == true &&
      isNotPhoneNumber == true
    ) {
      // check and remove occurance of +
      if (cursorPos > 0)
        value =
          value.substring(0, cursorPos) +
          userInput +
          value.substring(cursorPos, value.length);
      else value = userInput + value;

      value = value.split(AppConstants.LOGIN_SEPERATOR).pop();
      const prefixLength =
        this.state.maskedCountryCodePhoneNumber.length +
        AppConstants.LOGIN_SEPERATOR.length;
      this.setState({ caretPosition: cursorPos - prefixLength + 1 });
    }

    return {
      value,
      selection,
    };
  },

  onPasswordChange(password) {
    this.setState({ password: password });
  },

  onLocalChange(localeId) {
    this.setState({ localeId: localeId });
  },

  prefillLoginInput() {
    const { loginId } = this.props;
    loginId ? this.setState({ loginId, focusPasswordInput: true }) : null
  },

  setLoginState(value) {
    this.setState(value);
  },

  setOtherIds(otherIds) {
    this.loginId = "";
    this.setState({ otherIds, loginId: "" });
  },

   vpnRequestDetectionV2(){
    LoginActions.setIsIntranetRequestV2();
    let appState = LoginStore.getState();

    return appState.IsIntranetRequestV2;
  },

  renderLoginLink() {
    let isInternalRequest = window.WebConstants && (window.WebConstants.requestType == AppConstants.INTRANET_REQUEST || window.WebConstants.requestType == AppConstants.EXTERNAL_REQUEST);
    let isInternetRequest = window.WebConstants && window.WebConstants.requestType == AppConstants.INTERNET_REQUEST && this.state.showLoginAsEmployeeLinkInInternet;
    let showEmployeeLoginLink = this.state.isNewVpnEnabled ? (this.state.renderLoginLogic || this.state.showLoginAsEmployeeLinkInInternet) : (isInternalRequest || isInternetRequest);
    if(showEmployeeLoginLink){
      let props = this.props;
      const loginAsEmployee = this.props.intl.formatMessage(
        defaultMessages["loginAsEmployee"]
      );
      const url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        AppConstants.UrlParams.CLIENT_ID +
        "=" +
        props.clientId +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.REDIRECT_URI,
          encodeURIComponent(props.redirectUrl)
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.USER_TYPE,
          AppConstants.UserTypes.EMP
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.RESPONSE_TYPE,
          props.responseType
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.COUNTRY_CODE,
          props.countryCode
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.LOCALE_ID,
          this.state.localeId
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.REALM_ID,
          props.realmId
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.ACCOUNT_ID,
          props.accountId
        ) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.PROMPT, props.prompt) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.CODE_CHALLENGE,
          props.codeChallenge
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.CODE_CHALLENGE_METHOD,
          props.codeChallengeMethod
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.PREVIEW,
          this.props.preview
        ) +
        UrlUtils.appendQueryParam(
          AppConstants.UrlParams.TRACE_ID,
          this.props.traceId
        );
      return (
        <div>
          <span className="pull-right-lg pull-right-md">
            <a href={url} className="boldTextLabel">
              {loginAsEmployee}
            </a>
          </span>
        </div>
      );
    }
  },

  renderTOTPForm() {
    return (
      <TwoFactorAuthenticationRenderer
        {...this.props}
        phone={this.state.phone}
        emailId={this.state.emailId}
        login={this.loginId}
        idToken={this.state.idToken}
        twoFaAuthMethod={this.state.showTOTPControl}
        authMethodDeviceName={this.state.authMethodDeviceName}
        userMFAMethods={this.state.userMFAMethods}
      />
    );
  },

  renderLoginIdField() {
    const props = this.props;
    if (props.allowMobileLogin) {
      if (this.state.otherIds) {
        // render field for other Ids
        let label = props.intl.formatMessage(
          defaultMessages["metroIDCardNumberEtc"]
        );
        let linkText = props.intl.formatMessage(
          defaultMessages["login.link.EmailOrMobile"]
        );
        return (
          <Input
            id="user_id"
            type="email"
            key="user_id"
            name="user_id"
            autoComplete="off"
            label={label}
            required={true}
            hasWarning={this.state.loginError ? true : false}
            defaultValue={this.props.loginId || ""}
            onChange={this.onLoginIdChange}
            onKeyUp={this.onLoginIdChange}
            onKeyDown={this.onLoginIdChange}
            autoFocus={true}
            link={linkText}
            onLinkClick={this.setOtherIds.bind(this, false)}
          />
        );
      } else {
        let label = props.intl.formatMessage(
          defaultMessages["login.link.EmailOrMobile"]
        );
        let linkText = props.intl.formatMessage(
          defaultMessages["login.link.OtherIds"]
        );
        let maskedCountryCodePhoneNumber = this.state
          .maskedCountryCodePhoneNumber;
        let maskedCountryPhoneNumber = this.state.maskedCountryPhoneNumber;
        let mask =
          maskedCountryCodePhoneNumber +
          AppConstants.LOGIN_SEPERATOR +
          maskedCountryPhoneNumber;
        if (this.state.isPhoneNumber) {
          return (
            <span id="loginIdBox">
              <div className="m-input m-input-user_id">
                <div className="m-label">
                  <label>{label}</label>
                  <a
                    onClick={this.setOtherIds.bind(this, true)}
                    className="m-label-link blueTextLabel"
                  >
                    {linkText}
                    <span className="tooltiptext">
                      {this.props.intl.formatMessage(
                        defaultMessages["login.link.OtherId.Tooltip"]
                      )}
                    </span>
                  </a>
                </div>
                <div className="m-input-elementWrapper">
                  <InputMask
                    id="user_id"
                    name="user_id"
                    autoComplete="off"
                    mask={mask}
                    maskChar={""}
                    value={this.state.loginId}
                    className={
                      "m-input-element" +
                      (this.state.hasWarning ? " m-input-hasWarning" : "")
                    }
                    autoFocus={true}
                    onChange={this.onLoginIdChange}
                    beforeMaskedValueChange={this.beforeMaskedValueChange}
                  />
                </div>
              </div>
            </span>
          );
        } else {
          return (
            <span id="loginIdBox">
              <Input
                id="user_id"
                type="text"
                key="user_id"
                name="user_id"
                autoComplete="off"
                label={label}
                required={true}
                hasWarning={this.state.loginError ? true : false}
                value={this.state.loginId}
                onChange={this.onLoginIdChange}
                onKeyUp={this.onLoginIdChange}
                onKeyDown={this.onLoginIdChange}
                autoFocus={true}
                link={linkText}
                onLinkClick={this.setOtherIds.bind(this, true)}
              />
            </span>
          );
        }
      }
    }
    // return old login field
    let label = props.intl.formatMessage(defaultMessages["userId"]);
    return (
      <Input
        id="user_id"
        type="email"
        key="user_id"
        name="user_id"
        autoComplete="off"
        label={label}
        required={true}
        hasWarning={this.state.loginError ? true : false}
        value={this.state.loginId}
        onChange={this.onLoginIdChange}
        onKeyUp={this.onLoginIdChange}
        onKeyDown={this.onLoginIdChange}
        autoFocus={true}
      />
    );
  },

  showSocialLogin() {
    return !AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.clientsToOmit.includes(this.props.clientId) && window.WebConstants.hdCountries.includes(this.props.countryCode);
  },

  submitButtonActiveStatus() {
    const { loginId, password, isClientPasswordless } = this.state;
    if (isClientPasswordless) {
      return !loginId
    }
    return !(loginId && password)
  },

  renderLogin() {
    let redirectToForgotPassword = this.state.forgotPwdLinkUrl + UrlUtils.appendQueryParam(AppConstants.UrlParams.PASSWORDLESS, this.state.isClientPasswordless);
    const loginButtonText = this.props.intl.formatMessage(
      defaultMessages["loginBtnTxt"]
    );
      return (
      <React.Fragment>
        <LoginBoxWrapper>
          <div >
          {this.state.isClientPasswordless && <p className="passwordless">{this.props.intl.formatMessage(defaultMessages["passwordlessHeaderText"])}</p>}
            <form
              id="authForm"
              noValidate="novalidate"
              onSubmit={event => event.preventDefault()}
              autoComplete="off"
            >
              {this.renderLoginIdField()}
              <PasswordField
                clientId={this.props.clientId}
                placeholder={this.props.placeholder}
                intl={this.props.intl}
                onPasswordChange={this.onPasswordChange}
                forgotPasswordLinkUrl={this.state.forgotPwdLinkUrl}
                focusInput={this.state.focusPasswordInput}
              />
              <LoginHiddenFields {...this.props} />
              <Button
                id="submit"
                type="submit"
                value="submit"
                kind="primaryRaised"
                size="large"
                className="primary-button"
                almostActive={this.submitButtonActiveStatus()}
                onClick={Utils.debounce(this.onLogin)}
              >
                {loginButtonText}
              </Button>
            </form>
            <div className="externalUserTypeContainer">
              <div onClick={() => this.googleAnalyticsSendForgotPassEvents()}>
                {this.state.forgotPwdLinkUrl && (
                  <a href={redirectToForgotPassword} className="boldTextLabel">
                    {this.props.intl.formatMessage(
                      defaultMessages["forgotPassword"]
                    )}
                  </a>
                )}
              </div>
              <div className="loginAsEmployee">{this.renderLoginLink()}</div>
            </div>
          </div>
        </LoginBoxWrapper>
        {this.showSocialLogin() && this.renderSocialLogin()}
        {/* {this.renderSocialLoginModal()} */}
      </React.Fragment>
    );
  },

  toggleCards() {
    const { isLoginCardVisible } = this.state;
    this.googleAnalyticsSendRegistersEvents();
    this.setState({ isLoginCardVisible: !isLoginCardVisible });
  },

  renderOnlyLoginContent() {
    let props = this.props;
    const { hideYouAndMetroDigitalComponent } = this.state;
    let headerMessage = LoginHelper.getloginHeader(props);
    let renderedComponent = this.state.showTOTPControl
      ? this.renderTOTPForm()
      : this.renderLogin();

    let loginCardOpenStatus = this.state.isLoginCardVisible ? "open" : "";
    let registerCardOpenStatus = !this.state.isLoginCardVisible ? "open" : "";

    return (
      <div>
        <div className="employeeBoxContainer container">
          <div className="col-md-3 col-sm-2 col-xs-0" />
          <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
            <div className="row whiteContainer newDesign larger-device-width smaller-device">
              <div
                className={`col-xs-12 smaller-device-inside-wrap loginCard ${loginCardOpenStatus}`}
              >
                {!hideYouAndMetroDigitalComponent &&
                  this.renderRegisterContent(registerCardOpenStatus)}
                {!loginCardOpenStatus && (
                  <div className="togglePreviewContent">
                    <div className="previewTitle">
                      {this.props.intl.formatMessage(defaultMessages["loginpage.have_account"])}
                    </div>
                    <div className="registerLink">
                      <span className="previewButton" onClick={() => this.toggleCards()}>{this.props.intl.formatMessage(defaultMessages["loginBtnTxt"])}</span>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="form-group centreAligned loginHeader">
                      <h1 className="customer-h1">{headerMessage}</h1>
                    </div>
                  </div>
                </div>
                {renderedComponent}
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-2 col-xs-0" />
        </div>
        <LoginHandler
          {...props}
          loginId={this.state.loginId}
          localeId={this.state.localeId}
          setState={(value) => { this.setLoginState(value) }}
        />
        <AuthMethodsHandler
          {...props}
          setState={(value) => { this.setLoginState(value) }}
        />
      </div>
    );
  },

  handleModalOpen(modalStatus, eventAction = '', eventLabel = '') {
    if (eventAction) {
      Utils.setGASocialLoginDataLayerEvent(eventAction, eventLabel);
    }

    this.setState({ isSocialModalOpen: modalStatus });
  },

  handleSocialLoginElementHover(eventAction = '', eventLabel = '') {
    Utils.setGASocialLoginDataLayerEvent(eventAction, eventLabel);
  },

  handleDishButtonClick(eventAction, eventLabel) {
    const { props } = this;

    Utils.setGASocialLoginDataLayerEvent(eventAction, eventLabel);

    const url =
      window.location.protocol +
      "//" +
      window.location.host +
      AppConstants.Links.SOCIAL_LOGIN_REDIRECT_URL +
      "?" +
      AppConstants.UrlParams.CLIENT_ID +
      "=" +
      AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.clientId +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.REALM_ID,
        AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.realmId
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.LOCALE_ID,
        this.state.localeId
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.REDIRECT_URI,
        AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.redirectUrl[window.WebConstants.stage]
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.USER_TYPE,
        AppConstants.UserTypes.CUST
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.RESPONSE_TYPE,
        props.responseType
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.COUNTRY_CODE,
        props.countryCode
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.PROVIDER,
        AppConstants.Providers.KEYCLOAK
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.SCOPE,
        AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.scope
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.STATE,
        AppConstants.SOCIAL_LOGIN.DISH_CONSTANTS.state
      ) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.PROMPT, props.prompt) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.SLP_FINAL_REDIRECT_URI,
        encodeURIComponent(props.redirectUrl)
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.SLP_FINAL_CLIENT_ID,
        props.clientId
      ) +
      UrlUtils.appendQueryParam(
        AppConstants.UrlParams.SLP_FINAL_REALM_ID,
        props.realmId
      );

    window.location = url;
  },

  renderSocialLogin() {
    return (
      <div className="socialLoginContainer">
        <div className="textContainer">
          <div className="separatorWidth">
            <Separator />
          </div>
          <div className="separatorText">
            {this.props.intl.formatMessage(defaultMessages["loginpage.login_with"])}
          </div>
          <div className="separatorWidth">
            <Separator />
          </div>
        </div>
        <div className="imagesContainer">
          <div className="dish" onClick={() => this.handleDishButtonClick('click', 'dish')} onMouseEnter={() => { this.handleSocialLoginElementHover('hover', 'dish') }}>
            <img
              className="socialLogo dishLogo"
              alt="Dish Authentication"
              src="assets/images/Logo_Dish_Color_RGB.png"
            />
            <div>
              {this.props.intl.formatMessage(defaultMessages["loginpage.login_with_dish"])}
            </div>
          </div>
        </div>
      </div>
    );
  },

  renderSocialLoginModal() {
    const { isSocialModalOpen } = this.state;
    return (
      <Modal aria-labelledby="modal-title" isOpen={isSocialModalOpen}>
        <ModalContent direction="column" padding="large" spacing="medium">
          <div className="socialModalContainer">
            <div className="modalTitle">
              {this.props.intl.formatMessage(defaultMessages["loginpage.modal.social_login_title"])}
            </div>
            <div className="modalContent">
              {this.props.intl.formatMessage(defaultMessages["loginpage.modal.social_login_text"])}
            </div>
            <div className="loginWithEmailButton">
              <button
                className="closeModalButton"
                onClick={() => this.handleModalOpen(false)}
              >
                {this.props.intl.formatMessage(defaultMessages["loginpage.modal.social_login_button"])}
              </button>
            </div>
          </div>
        </ModalContent>
      </Modal>
    );
  },

  renderRegisterContent(cardOpenStatus) {
    const { customerComponentLinks } = this.state;

    /*
      If there is only one register webconfig, there will be no cards toggle
    */
    const validWebconfigArray = Object.values(customerComponentLinks).filter(webConfig => webConfig !== "");
    const hasOnlyOneWebConfig = validWebconfigArray.length === 1;

    if (cardOpenStatus === "") {
      return (
        <div className={`registerCard ${cardOpenStatus}`}>
          <div className="togglePreviewContent">
            <div className="previewTitle">
              {this.props.intl.formatMessage(defaultMessages["loginpage.login_new_digital_account"])}
              <Tooltip id="login-tooltip" description={this.props.intl.formatMessage(defaultMessages["loginpage.tooltip_message"])} >
                <span className="previewTitleTooltip"><Info color="grey" dimensions={{ width: 1, height: 1 }} /></span>
              </Tooltip>
            </div>
            {hasOnlyOneWebConfig ?
              (
                <div className="registerLink" onClick={()=>{this.googleAnalyticsSendRegistersEvents()}}>
                  <a href={validWebconfigArray[0]} >
                    {this.props.intl.formatMessage(
                      defaultMessages["loginpage.login_create_one"]
                    )}
                  </a>
                </div>
              ) : (<div className="registerLink">
                <span className="previewButton" onClick={() => this.toggleCards()}>{this.props.intl.formatMessage(defaultMessages["loginpage.login_create_one"])}</span>
              </div>)
            }
          </div>
        </div>
      );
    }
    return (
      <div className={`registerCard ${cardOpenStatus}`}>
        <div className="registerCardTitle">
          {this.props.intl.formatMessage(defaultMessages["loginpage.register"])}
        </div>
        <div className="registerCardContainer">
          {this.state.customerComponentLinks.createLogin && (
            <React.Fragment>
              <div className="registerText">
                {this.props.intl.formatMessage(
                  defaultMessages["alreadyAMetroCustomer"]
                )}
              </div>
              <div className="registerButton">
                <a href={this.state.customerComponentLinks.createLogin}>
                  <button className="primary-button">
                    {this.props.intl.formatMessage(
                      defaultMessages["createLogin"]
                    )}
                  </button>
                </a>
              </div>
            </React.Fragment>
          )}
          {this.state.customerComponentLinks.newCustomerSignUpButton && (
            <div>
              <div className="registerText">
                {this.props.intl.formatMessage(
                  defaultMessages["areYouNewToMetroDigital"]
                )}
              </div>
              <div className="registerButton">
                <a
                  href={
                    this.state.customerComponentLinks.newCustomerSignUpButton
                  }
                >
                  <button className="primary-button">
                    {this.props.intl.formatMessage(
                      defaultMessages["newCustomerSignUpButton"]
                    )}
                  </button>
                </a>
              </div>
            </div>
          )}
          {this.state.customerComponentLinks.signUpLink && (
            <React.Fragment>
              <div className="registerText">
                {this.props.intl.formatMessage(
                  defaultMessages["signUpLinkLabel"]
                )}
              </div>

              <div className="registerButton">
                <a href={this.state.customerComponentLinks.signUpLink}>
                  <button className="primary-button">
                    {this.props.intl.formatMessage(
                      defaultMessages["signUpLink"]
                    )}
                  </button>
                </a>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  },

  renderFooter: function () {
    return (
      <IntlProvider
        locale={this.state.localeId}
        messages={this.props.translations}
      >
        <div className="fixFooterBottom">
          <FooterMinimal
            {...this.props}
            locale={this.state.localeId}
            onLocalChange={this.onLocalChange}
          />
        </div>

      </IntlProvider>
    );
  },

  render: function () {
    return (
      <PageCase
        header={<Header />}
        content={this.renderOnlyLoginContent()}
        footer={this.renderFooter()}
        headerSpacing={"header-spacing"}
      ></PageCase>
    );
  },
});

module.exports = injectIntl(CustomerLogin);
